import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { Accordion, AccordionDetails, AccordionSummary, Grid } from "@mui/material";
// import { isMobile } from "react-device-detect";
import styled from "styled-components";
import { usePallet } from "../../../../contexts/PalletContext";
import { useNavigate } from "react-router-dom";
import MenuButtonIconEditActive from './MenuButtonIconEditActive';
import { isMobile } from 'react-device-detect';
import { useEffect, useState } from 'react';
import TCService from '../../../../services/TCService';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styled2 from "styled-components";

export interface IMenuButtonEditActive {
  idregister: number,
  active: boolean,
  path?: string
}

//## StyledCompenents
const TemaContent = styled(Grid)`
 align-items: center;
 border: 1px solid #EAEAEA;
 border-radius: 4px;
 margin: 5px 0;

 div.not-header {
     display: flex;
     flex-wrap: wrap;
     align-items: center;
     width: 100%;
     flex-direction: row;
     color: #1E0736;
     font-size: 15px;

     a { 
      cursor: pointer;
     }
     
     strong {
       font-size: 17px;
       margin: 0 20px;
     }
     p {
       font-size: 17px;
       font-weight: bold;
       color: #4B1196;
       margin: 0 10px 0 0;
     }
 }
 div.not-header-icon {
     background-color: #F2F2F2;
     width: 50px;
     height: 50px;
     display: flex;
     align-items: center;
     justify-content: center;
     border-radius: 4px 0px 0 4px;

     svg {
         color: #9B9B9B;
     }

     &.active {
       background-color: #DED3FF;

       svg { 
         color: #4B1196;
       }
     }
 }
`;


const DotPrioridade = styled2.div`
background-color: ${(props => props.bg)};
border-radius: 50%;
height: 8px;
width: 8px;
margin-right: 3px;
`;


const TemaContentMob = styled(Grid)`
 border: 1px solid #EAEAEA;
 border-radius: 4px;


 div.not-header {
     color: #1E0736;
     font-size: 15px;

     a { 
      cursor: pointer;
     }
     
     strong {
       font-size: 17px;
       margin: 0 20px;
       }
       

 }
 div.not-header-icon {
     background-color: #F2F2F2;
     width: 50px;
     height: 50px;
     display: flex;
     align-items: center;
     justify-content: center;
     border-radius: 4px 0px 0 4px;

     svg {
         color: #9B9B9B;
     }

     &.active {
       background-color: #DED3FF;

       svg { 
         color: #4B1196;
       }
     }
 }
`;

export default function TemaCorporativoCardSubtema(props: {
  tema_id: number,
  tema_descricao: string,
  tema_seativo: boolean,
  tema_id_prioridade:number,
  onChange?: () => void

}) {
  const { pallet } = usePallet();
  const navigate = useNavigate();
  const [listaTema,setListaTema] = useState([]);
  const [accordionOpen, setAccordionOpen] = useState(false);

  useEffect(() => {
}, [props.tema_id]);



const corPrioridade = (value: number) => {

  switch (value) {
      case 5:
          return `${pallet.charts.red}`;
      case 4:
          return `${pallet.charts.blue}`;
      case 3:
          return `${pallet.charts.yellow}`;
      case 2:
          return `${pallet.charts.purple}`;
      case 1:
          return `${pallet.charts.green}`;
      default:
          return `${pallet.charts.lightGrey}`;
  }
}


const descPrioridade = (value: number) => {

  switch (value) {
      case 1:
          return 'Mínima';
      case 2:
          return 'Baixa';
      case 3:
          return 'Média';
      case 4:
          return 'Alta';
      case 5:
          return 'Máxima';
      default:
          return '';
  }
}



  
  return (
    <>
  {

    isMobile ?
    <TemaContentMob>

      <Grid  style={{wordBreak:"break-word",display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
            <Grid>
              <div className={`not-header-icon ${props.tema_seativo ? "active" : ""}`}>
                <AccountTreeIcon />
              </div>
            </Grid>
            <Grid style={{ alignSelf: "center",justifyContent:"center",textAlign:"center" }}>
              <a onClick={() => navigate(`/classificacaodetemas/tema/${props.tema_id}`)}>
                <strong>{props.tema_descricao}</strong>
              </a>
            </Grid>
          

        <Grid>
          <MenuButtonIconEditActive
            idregister={props.tema_id}
            seativo={props.tema_seativo}
            onChange={props.onChange}
          />

        </Grid>

      </Grid>

  </TemaContentMob>

  :
  <TemaContent>
  <div className="not-header">
    <Grid container justifyContent={"space-between"}>
      <Grid>
        <Grid container>
          <Grid>
            <div className={`not-header-icon ${props.tema_seativo ? "active" : ""}`}>
              <AccountTreeIcon />
            </div>
          </Grid>
          <Grid style={{ display:'flex', justifyContent:'center',alignContent:'center',alignSelf:"center"}}>
            <a onClick={() => navigate(`/classificacaodetemas/tema/${props.tema_id}`)}>
              <strong>{props.tema_descricao}</strong></a>
              <Grid style={{ display:'flex'}}>
                  {props.tema_id_prioridade ? 'Prioridade: ' : null}
               {props.tema_id_prioridade ?
                          <Grid style={{marginTop:'5px'}}>
                           <DotPrioridade
                                    bg={corPrioridade(
                                        props.tema_id_prioridade
                                    )}
                                ></DotPrioridade>
                                </Grid>  : null} 

                {props.tema_id_prioridade ? descPrioridade(props.tema_id_prioridade) : null}

              </Grid>
            
          </Grid>
        </Grid>
      </Grid>



    </Grid>
  </div>
</TemaContent>


    

//   <TemaContent>
//   <div className="not-header">
//     <Grid container justifyContent={"space-between"}>
//       <Grid>
//         <Grid container>
//           <Grid>
//             <div className={`not-header-icon ${props.tema_seativo ? "active" : ""}`}>
//               <AccountTreeIcon />
//             </div>
//           </Grid>
//           <Grid style={{ alignSelf: "center" }}>
//             <a onClick={() => navigate(`/classificacaodetemas/tema/${props.tema_id}`)}>
//               <strong>{props.tema_descricao}</strong>
//             </a>
//           </Grid>
//         </Grid>
//       </Grid>

//       <Grid>
//         <MenuButtonIconEditActive
//           idregister={props.tema_id}
//           seativo={props.tema_seativo}
//           onChange={props.onChange}
//         />

//       </Grid>

//     </Grid>
//   </div>
// </TemaContent>
    
  }

    </>
  )
}